import { h } from 'preact'

const lang = navigator.language

interface Props {
  datetime: number
}

const DateInOEmbed = ({ datetime }: Props) => {
  const date = new Date(datetime * 1000)

  const dateOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  }
  const timeOptions = {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  }
  const dateTimeOptions = { ...dateOptions, ...timeOptions }
  const formattedDate = date.toLocaleDateString(lang, dateTimeOptions)
  return <span>{ formattedDate }</span>
}

export default DateInOEmbed
